import React from 'react';
import { ProductOpenTable } from '../ProductOpenTable/ProductOpenTable.tsx';

interface Props {
    specs: { name: string, value: string }[]
}

/**
 * Блок с характеристиками товара
 * @param specs
 * @returns 
 */
export const ProductSpecs: React.FC<Props> = ({ specs }) => {

    return (
        <ProductOpenTable title='Характеристики'>
            <div className='overflow-x-auto mt-2 slide-down-element'>
                <table className='min-w-[320px] w-full text-sm border rounded-xl bg-white'>
                    <tbody>
                        {specs.map((spec, index) => (
                            <tr key={spec.name + index} className='even:bg-gray-50'>
                                <td className='py-2 px-3 font-medium text-gray-700 whitespace-nowrap'>{spec.name}</td>
                                <td className='py-2 px-3 text-gray-900'>{spec.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </ProductOpenTable>
    );
};